/** 侧栏 → 关联墙 的拖拽协议（独立模块，避免组件循环引用）。 */

export const DRAG_MIME = 'application/x-expotar-item';

export type DragPayload = {
  kind: 'target' | 'entity' | 'evidence' | 'timeline';
  id: string;
  title: string;
  text: string;
  color?: 'default' | 'blue' | 'green' | 'yellow' | 'red' | 'purple' | 'orange';
  photo?: string;
};

export function readDragPayload(event: { dataTransfer: DataTransfer }): DragPayload | null {
  const raw = event.dataTransfer.getData(DRAG_MIME);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as DragPayload;
  } catch {
    return null;
  }
}

export function writeDragPayload(
  event: { dataTransfer: DataTransfer },
  payload: DragPayload
): void {
  event.dataTransfer.setData(DRAG_MIME, JSON.stringify(payload));
  event.dataTransfer.effectAllowed = 'copy';
}